import React from "react";
import "./Careers.css";
import { Helmet } from "react-helmet-async";

const Careers = () => {
    return (
        <>
           <Helmet>
    <title>PRT Academy Careers | Jobs & Career Opportunities in Hyderabad</title>

    <meta
        name="description"
        content="Explore careers at PRT Academy and discover job opportunities in Hyderabad for IT trainers, developers, and professionals seeking rewarding career growth."
    />

    <meta
        name="keywords"
        content="PRT Academy Careers,PRT Academy Jobs,
Careers at PRT Academy,
PRT Academy Job Openings,
PRT Academy Career Opportunities,
Software Trainer Jobs,
Career Growth"
    />
</Helmet>

            <section className="careers-page">

                <div className="page-badge">
                    Careers at PRT Academy
                </div>

                <h1>
                    Build Your Career <span>With Us</span>
                </h1>

                <p className="page-intro">
                    Join a team focused on building better learning experiences
                    and helping students start successful technology careers.
                </p>

                <div className="career-card">

                    <h2>We're Growing</h2>

                    <p>
                        We are always interested in connecting with passionate
                        developers, trainers, mentors and professionals who
                        want to make an impact in education and technology.
                    </p>

                   

                </div>

            </section>

            
        </>
    );
};

export default Careers;